<template>
  <v-main>

    <v-container
        id="users-container"
        fluid
        tag="section"
    >

      <base-material-card
          icon="mdi-account-off-outline"
          class="px-5 py-5"
      >

        <shared-page-messages :error-messages="errorMessages"
                              :warning-messages="warningMessages"
                              :success-messages="successMessages">
        </shared-page-messages>

          <v-row align="center">
            <v-col
                cols="12"
                sm="12"
                align="right"
            >

              <v-dialog
                  v-model="filtersDialog"
                  max-width="400"
              >

                <template v-slot:activator="{ on, attrs }">

                  <v-btn
                      small
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon size="small">mdi-filter</v-icon> Filters
                  </v-btn>
                </template>


                <form @submit.prevent="applyFilters">

                  <v-card>
                    <v-card-title class="text-h5">
                      Suspension Filters
                    </v-card-title>

                    <v-card-text>
                      <v-row dense>
                        <v-col
                            cols="12"
                        >
                          <v-combobox
                              v-model="filter.claim"
                              label="Claim"
                              placeholder="Start typing to search"
                              :items="computedClaimList"
                              :loading="isLoadingClaims"
                              :search-input.sync="claimSearchString"
                              @input.native="nativeClaimSearchString=$event.srcElement.value"
                              item-text="names"
                              item-value="id"
                              return-object
                              no-filter
                              persistent-placeholder
                              validate-on-blur
                              clearable
                          ></v-combobox>
                        </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col
                            cols="12"
                            sm="6"
                        >
                          <v-text-field
                              v-model="filter.firstName"
                              label="First Name"
                              dense
                          ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="6"
                        >
                          <v-text-field
                              v-model="filter.lastName"
                              label="Last Name"
                              dense
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col
                            cols="12"
                            lg="6"
                        >
                          <v-text-field
                              v-model="filter.startDate"
                              label="Start Date or Before"
                              type="date"
                              dense
                          ></v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                            lg="6"
                        >
                          <v-text-field
                              v-model="filter.endDate"
                              label="End Date or After"
                              type="date"
                              dense
                          ></v-text-field>
                        </v-col>
                      </v-row>


                      <v-row dense>
                        <v-col
                            cols="12"
                            sm="6"
                        >
                          <v-checkbox
                              v-model="filter.isActive"
                              label="Is Active"
                              dense
                          ></v-checkbox>
                        </v-col>
                      </v-row>

                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                          small
                          color="primary"
                          class="mx-1"
                          @click="filtersDialog = false"
                      >
                        Close
                      </v-btn>
                      <v-btn
                          small
                          color="primary"
                          class="mx-1"
                          type="submit"
                      >
                        Apply
                      </v-btn>
                      <v-btn
                          small
                          color="primary"
                          class="mx-1"
                          @click="resetFilters"
                      >
                        Reset
                      </v-btn>
                    </v-card-actions>

                  </v-card>

                </form>

              </v-dialog>
            </v-col>
          </v-row>

          <v-simple-table
              :headers="headers"
              :items="suspensions"
              :items-per-page="filter.itemsPerPage"
              class="elevation-1 mt-2 pt-2"
              loading-text="Loading... Please wait"
              dense
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="suspension-member text-subtitle-2">Member</th>
                  <th class="suspension-invoice-details text-subtitle-2">Replenishment/Details</th>
                  <th class="suspension-invoice-num text-subtitle-2">Inv. #</th>
                  <th class="suspension-period text-subtitle-2">Days</th>
                  <th class="suspension-start-date text-subtitle-2">Start Date</th>
                  <th class="suspension-end-date text-subtitle-2">End Date</th>
                  <th class="suspension-active text-subtitle-2">Active</th>
                </tr>
              </thead>
              <tbody>
              <tr
                  v-for="suspension in suspensions"
                  :key="suspension.id"
              >

                <td>
                  <router-link :to="{ name: 'edit_suspension', params: {memberId: suspension.user.id, suspensionId: suspension.id} }">
                    {{ suspension.user.names }}
                  </router-link>
                </td>
                <td>
                  <span v-if="suspension.invoice.id">
                    <router-link :to="{ name: 'view_invoice', params: {invoiceId: suspension.invoice.id} }">
                      {{ suspension.invoice.items[0].description }}
                    </router-link>
                  </span>
                </td>
                <td>
                  <span v-if="suspension.invoice.id">
                    <router-link :to="{ name: 'view_invoice', params: {invoiceId: suspension.invoice.id} }">
                      {{ suspension.invoice.id }}
                    </router-link>
                  </span>
                </td>
                <td>{{ suspension.period }}</td>
                <td>{{ suspension.startDate | formatLocalDate }}</td>
                <td>{{ suspension.endDate | formatLocalDate }}</td>
                <td>
                  <span v-if="suspension.isActive">Yes</span>
                  <span v-else>No</span>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div class="text-center mt-3">
            <v-pagination
                v-model="filter.page"
                :length="searchResponse.page.totalPages || 1"
                @input="fetchSuspensions"
            ></v-pagination>
          </div>

      </base-material-card>


    </v-container>

  </v-main>
</template>

<script>
import api from '@/services/api'
import SharedPageMessages from '../shared/PageMessages.vue'
import moment from 'moment-timezone'

export default {
  name: 'CoreSuspensionsView',
  components: {SharedPageMessages},

  async created () {
    await this.fetchSuspensions()
  },

  watch: {
    claimSearchString(val) {
      if (!this.isLoadingClaims && val !== null && (val.length > 2)) {
        this.fetchClaims(val)
      }
    },
    suspensions: function (val) {
      if (val.length === 0) {
        this.warningMessages.push("No suspensions matching your filter criteria found.")
      }
    },
    errorMessages: function (val) {
      if (val.length > 0) {
        scroll(0, 0)
      }
    },
    successMessages: function (val) {
      if (val.length > 0) {
        scroll(0, 0)
      }
    },
    warningMessages: function (val) {
      if (val.length > 0) {
        scroll(0, 0)
      }
    }
  },

  computed: {
    suspensions() {
      return this.searchResponse.content
    },
    computedSelectAll: {
      set: function (value) {
        this.successMessages = ''
        this.bulkActionItems = []
        if (value === true) {
          this.suspensions.forEach(suspension => {
            this.bulkActionItems.push(suspension.id)
          })
        }
      },
      get: function () {
        return this.suspensions.length > 0 && this.suspensions.length === this.bulkActionItems.length
      }
    },
    computedClaimList: {
      get() {
        return this.claims
            .map(claim => ({id: claim.id, names: `${claim.user.names} (${claim.dependent.names})`}))
      }
    },

  },

  methods: {
    clearMessages() {
      this.successMessages = []
      this.errorMessages = []
      this.warningMessages = []
    },

    applyFilters() {
      this.filtersDialog = false
      this.clearMessages()
      this.fetchSuspensions()
    },
    resetFilters() {
      this.filtersDialog = false
      this.clearMessages()
      this.filter = {
        firstName: '',
        lastName: '',
        startDate: '',
        endDate: '',
        isActive: null,
        itemsPerPage: 25,
        page: 1,
      }
      this.fetchMembers()
    },
    async fetchClaims(val) {
      this.clearMessages()
      this.isLoadingClaims = true
      let nameParts = val.split(' ')
      let firstPart = nameParts.shift()
      let lastPart = nameParts.pop() || firstPart
      let filters = {
        firstName: firstPart,
        lastName: lastPart
      }
      return api.searchClaims(filters)
          .then(response => {
            this.claims = response.data.content
          })
          .catch(err => {
            this.handleError(err)
          })
          .finally(() => this.isLoadingClaims = false)
    },
    async fetchSuspensions(page) {
      this.filter.page = page || 1
      let filterParams = {
        claimId: this.filter.claim ? this.filter.claim.id : null,
        firstName: this.filter.firstName,
        lastName: this.filter.lastName,
        startDate: this.filter.startDate ? moment.utc(this.filter.startDate).format('YYYY-MM-DD') : null,
        endDate: this.filter.endDate ? moment.utc(this.filter.endDate).format('YYYY-MM-DD') : null,
        isActive: this.filter.isActive,
        page: this.filter.page,
        limit: this.filter.itemsPerPage
      }
      return api.fetchSuspensions(filterParams)
          .then(response => {
            this.searchResponse = response.data
          })
          .catch(err => {
            this.handleError(err)
          })
    },

    handleError(err) {
      let errorMessage = api.parseResponseError(err, true)
      this.errorMessages.push(errorMessage)
    }
  },

  data() {
    return {
      valid: true,
      search: '',
      errorMessages: [],
      warningMessages: [],
      successMessages: [],
      bulkActionStatus: null,
      bulkActionItems: [],
      bulkActionValid: false,
      filterSuspensionStatus: null,
      filtersDialog: false,
      searchResponse: {
        content: [],
        empty: true,
        page: {
          totalPages: 0,
        }
      },
      filter: {
        claim: null,
        firstName: '',
        lastName: '',
        startDate: '',
        endDate: '',
        isActive: null,
        page: 1,
        itemsPerPage: 25,
      },
      claims: [],
      selectedClaims: [],
      claimSearchString: '',
      nativeClaimSearchString: '',
      isLoadingClaims: false,
    }
  },
}
</script>

<style lang="sass">
  th.suspension-active, th.suspension-period
    width: 5%

  th.suspension-invoice-num
    width: 8%

  th.suspension-invoice, th.suspension-start-date, th.suspension-end-date
    width: 10%

  .v-btn
    margin-right: 10px
    margin-left: 10px


</style>
